import { GET_REJECTED_POSTS, SET_CURRENT_POSTS, SET_CONTACT_LIST, SET_UPDATED_EVENT, UPDATE_PENDING_POSTS, GET_ALL_POSTS, UPDATE_EVENT_DETAILS, CLEAR_EVENT_STATE, CLEAR_IMAGE, SET_EVENT_TEMPLATE, SET_UPLOADED_IMAGE, UPDATE_EVENT_LIST, SET_EVENT_TO_EDIT, UPDATE_USERS_LIST } from '../../constants/action-constants';

const INIT_STATE = {
    bannerInfo: [],
    locationInfo: [],
    standardProgram: [],
    allEvents: [],
    eventLocations: [],
    eventToEdit: null,
    allTemplates: [],
    uploadedImage: null,
    updateEvent: null,
    allContacts: [],
    allUsers: [],
    pendingPosts: [],
    allPosts: [],
    rejectedPosts: [],
    currentPost: null,
}

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SET_CONTACT_LIST: {
            return {
                ...state,
                allContacts: action.payload,
            };
        }
        case UPDATE_PENDING_POSTS: {
            return {
                ...state,
                pendingPosts: action.payload,
            };
        }
        case SET_UPDATED_EVENT: {
            return {
                ...state,
                updateEvent: action.payload,
            };
        }
        case UPDATE_EVENT_LIST: {
            return {
                ...state,
                allEvents: action.payload,
            };
        }
        case SET_EVENT_TO_EDIT: {
            return {
                ...state,
                eventToEdit: action.payload,
            };
        }
        case UPDATE_USERS_LIST: {
            return {
                ...state,
                allUsers: action.payload,
            };
        }
        case CLEAR_EVENT_STATE: {
            return {
                ...state,
                updateEvent: null,
            };
        }
        case SET_UPLOADED_IMAGE: {
            return {
                ...state,
                uploadedImage: action.payload.filename,
            };
        }
        case CLEAR_IMAGE: {
            return {
                ...state,
                uploadedImage: null,
            };
        }
        case UPDATE_EVENT_DETAILS: {
            return {
                ...state,
                allContacts: action.payload,
            };
        }
        case GET_ALL_POSTS: {
            return {
                ...state,
                allPosts: action.payload,
            };
        }
        case GET_REJECTED_POSTS: {
            return {
                ...state,
                rejectedPosts: action.payload,
            };
        }
        case SET_CURRENT_POSTS: {
            return {
                ...state,
                currentPost: action.payload,
            };
        }
        default:
            return state;
    }
};